import React from 'react';
import PropTypes from 'prop-types';
import TextArea from '../TextArea';
import styles from './styles.css';

class CollapsibleTextAreaWithCounter extends React.PureComponent {
  static propTypes = {
    maxLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    rows: PropTypes.number,
    value: PropTypes.string,
  };

  static defaultProps = {
    maxLength: 280,
    rows: 4,
  };

  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };
  }

  handleFocus = (e) => {
    this.setState({
      collapsed: false,
    });
  }

  handleBlur = (e) => {
    this.setState({
      collapsed: true,
    });
  }

  handleChange = (e, props) => {
    if (!this.state.collapsed) {
      const { value } = props;
      const { onChange, maxLength } = this.props;
      if (value.length < maxLength) {
        onChange(e, props);
      } else {
        onChange(e, {
          ...props,
          value: value.substring(0, maxLength),
        });
      }
    }
  }

  handleRef = (ref) => {
    if (ref) {
      this.ref = ref.ref;
    }
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState({
      collapsed: false,
    });
    this.ref.current.focus();
  }

  /*
   * Disabling this rule due to the focus is still handled by the TextArea component
   * Focus and tab index will always react the textarea rather than the paragraph.
   * The paragraph will only receive a click action and it is only for visualization
   *
   */
  render() {
    const { collapsed } = this.state;
    const { value, rows, maxLength, ...rest } = this.props;

    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    return (
      <div
        className={styles.container}
      >
        { collapsed && <p onClick={this.handleClick} className={styles.collapsed}>{value}</p> }
        <TextArea
          ref={this.handleRef}
          {...rest}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          value={value}
          className={collapsed ? styles.inputCollapsed: ''}
          rows={rows}
        />

        { !collapsed && <p className={styles.counter}>{value.length}/{maxLength} Characters</p> }
      </div>
    );
    /* eslint-enable jsx-a11y/click-events-have-key-events */
    /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
  }
}

export default CollapsibleTextAreaWithCounter;
